import React, { FunctionComponent } from 'react';
import { Grid, Placeholder } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

const styles = {
  container: {
    backgroundColor: '#fff !important',
    borderRadius: '.25rem !important',
    border: 'none !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    justifyContent: 'space-between !important',
    margin: '.625em -1em !important',
    padding: '.4rem !important',
    width: '100% !important',
    height: '8.48125rem !important',
  },
  header: {
    '&&': {
      marginBottom: '1.875rem',
      paddingLeft: '1rem',
      color: '#646464',
    },
  },
  statsRow: {
    padding: '0 !important',
  },
  section: {
    alignItems: 'flex-end !important',
  },
  KeyMetrics: {
    paddingLeft: '0 !important',
  },
  budget: {
    paddingRight: '0 !important',
  },
  linePlaceholder: {
    height: '0.25rem !important',
    '&:before': {
      height: '.2rem !important',
    },
    '&:after': {
      height: '.2rem !important',
    },
  },
  imagePlaceholder: {
    height: '5.5rem !important',
    '&:before': {
      height: '.25rem !important',
    },
  },
};

type Props = {
  classes: ClassProp<typeof styles>;
};

const statPlaceholder = (classes: ClassProp<typeof styles>) => (
  <Grid.Column>
    <Placeholder>
      <Placeholder.Line className={classes.linePlaceholder} />
      <Placeholder.Image className={classes.imagePlaceholder} />
      <Placeholder.Line className={classes.linePlaceholder} length="full" />
    </Placeholder>
  </Grid.Column>
);

const renderKeyMetricsPlaceholder = (classes: ClassProp<typeof styles>) => (
  <Grid container className={classes.container} columns={'equal'}>
    <Grid.Row className={classes.statsRow}>
      {statPlaceholder(classes)}
      {statPlaceholder(classes)}
      {statPlaceholder(classes)}
      {statPlaceholder(classes)}
      {statPlaceholder(classes)}
      {statPlaceholder(classes)}
    </Grid.Row>
  </Grid>
);

const MerchantQuickLookPlaceholder: FunctionComponent<Props> = ({
  classes,
}) => (
  <Grid>
    <Grid.Row className={classes.section}>
      <Grid.Column className={classes.KeyMetrics} width={16}>
        {renderKeyMetricsPlaceholder(classes)}
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default withStyles(styles)(MerchantQuickLookPlaceholder);
